module.exports = __webpack_public_path__ + "static/ipad-52009922a9961c2176e9c0bb3ca2958d.jpg";